import React, {useRef, useEffect} from "react";
import {SketchPicker} from 'react-color';
import {hexToRGB} from "@/utils/colors";

export interface ColorPickerOptions {
    color: string
    defaultColor: string
    onChange: any
}


const ColorPicker = (props: ColorPickerOptions) => {
    const [opened, setOpened] = React.useState(false)

    const [color, setColor] = React.useState(props.color)

    function useOutsideAlerter(ref: any) {
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpened(false)
                }
            }

            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    return (
        <div className="px-3 py-2 form-control flex items-center justify-between relative">
            <div onClick={() => {
                setOpened(true)
            }}
                 className="w-8 h-8 cursor-pointer border-2 rounded" style={{backgroundColor: `${props.color}`}}
            />
            <div>

            <span onClick={() => {
                    props.onChange({
                        hex: props.defaultColor,
                        rgb: hexToRGB(props.defaultColor),
                    })
                }}
                  className="ml-4 text-blue cursor-pointer">
                Reset
            </span>
            </div>
            <div ref={wrapperRef} className="absolute z-[9999]">
                {opened &&
                    <SketchPicker
                        width={300}
                        color={color}
                        onChangeComplete={(color: any) => {
                            setColor(color)
                            props.onChange(color)
                        }}
                    />
                }
            </div>
        </div>
    )
}

export default ColorPicker;